import apiClient from './apiClient';

// ============================================
// Types
// ============================================

export interface ClientGroup {
    id: string;
    name: string;
    description: string;
    memberCount: number;
    createdAt: string;
}

export interface ClientGroupRequest {
    name: string;
    description: string;
    clientIds?: string[];
}

// ============================================
// API
// ============================================

export const clientGroupApi = {
    getGroups: async (salonId: string): Promise<ClientGroup[]> => {
        const response = await apiClient.get<ClientGroup[]>(`/salons/${salonId}/client-groups`);
        return response.data;
    },

    createGroup: async (salonId: string, data: ClientGroupRequest): Promise<ClientGroup> => {
        const response = await apiClient.post<ClientGroup>(`/salons/${salonId}/client-groups`, data);
        return response.data;
    },

    deleteGroup: async (salonId: string, groupId: string): Promise<void> => {
        await apiClient.delete(`/salons/${salonId}/client-groups/${groupId}`);
    },
};
